module.exports = __webpack_public_path__ + "static/media/997725.527154b5.jpg";